import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './idb-bio-block.css.lit';
import { OutlineElement } from 'src/components/base/outline-element/outline-element';
import '../../base/outline-grid/outline-grid';
import '../../base/outline-grid/outline-column/outline-column';

/**
 * The IDB Bio Block component.
 * @element idb-bio-block
 * @extends OutlineElement
 */
@customElement('idb-bio-block')
export class IdbBioBlock extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html`
      <section>
        <outline-grid>
            <outline-column col-span-default="12" col-span-md="5" content-align="top">
                <slot name="image"></slot>
            </outline-column>
            <outline-column col-span-default="12" col-span-md="7" content-align="top">
                <slot name="bio-info"></slot>
            </outline-column>
        </outline-grid>
      </section>
    `;
  }
}
